//控制瀏覽器捲軸、按鈕
class BodyCtrl {
  constructor() {
    this.body = $('body');
  }
  ctrl(settings) {
    switch (settings) {
      case 'scrollHide':
        this.body.addClass('scrollHide');
        break;
      case 'scrollShow':
        this.body.removeClass('scrollHide');
        break;
      case 'scrollHideF':
        this.body.addClass('scrollHideF');
        break;
      case 'scrollShowF':
        this.body.removeClass('scrollHideF');
        break;
      case 'btnLock':
        this.body.css('pointer-events', 'none');
        break;
      case 'btnUnlock':
        this.body.css('pointer-events', 'auto');
        break;
    }
  }
}




//輸出
export {BodyCtrl};

//jQuery 模組化
/*
(function($){
  $.fn.test = function(settings){
    //指定物件
    var $this = this;

    //設定初始預設並帶入此專案
    var status = $.extend({
      s: 'test'
    }, settings);

    var ss = status.s;

    //邏輯函式區
    var t = function($this){
      $this.on('click', function(){
        alert(ss);
      });
    }

    //輸出
    t();
  }
})(jQuery);

$('element').test();

$('element').test({
  s: 'test_'
});
*/

//直接鎖定瀏覽器捲軸目前位置(無顯示影藏)
/*
var scrollLock     = false;
var scrollPosition = {left: 0, top: 0};
$(window).on('scroll', function(){
  if (scrollLock) {
    window.scrollTo(scrollPosition.left, scrollPosition.top);
  } else {
    scrollPosition = {
      lelf: self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
      top : self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    };
  }
});
*/


// WEBPACK FOOTER //
// ./js_new/body_ctrl.js